import keyMirror from 'keymirror';

import { FRONTEND_ROUTES } from '@/services/Constants';

export const parentPasswordModalActionTypes = keyMirror({
	VALIDATE_PARENT_PASSWORD_REQUEST: null,
	VALIDATE_PARENT_PASSWORD_SUCCESS: null,
	VALIDATE_PARENT_PASSWORD_ERROR: null,
	RESET_PARENT_PASSWORD_VALIDATION: null,
	UPDATE_PARENT_VERIFICATION: null,
	OPEN_PARENT_PASSWORD_MODAL: null,
	CLOSE_PARENT_PASSWORD_MODAL: null,
});

export const pathsToPageNameMap = {
	[FRONTEND_ROUTES.GOAL_SETTINGS]: 'goal-settings',
	[FRONTEND_ROUTES.SETTINGS]: 'settings',
	[FRONTEND_ROUTES.PROGRESS]: 'progress',
	[FRONTEND_ROUTES.ACTIVITY]: 'activity',
};

export const parentPasswordProtectedRoutes = [
	FRONTEND_ROUTES.GOAL_SETTINGS,
	FRONTEND_ROUTES.SETTINGS,
	FRONTEND_ROUTES.PROGRESS,
	FRONTEND_ROUTES.ACTIVITY,
];

export const namespacesToPathMap = {
	update_learning_goals: FRONTEND_ROUTES.GOAL_SETTINGS,
	view_settings_page: FRONTEND_ROUTES.SETTINGS,
	view_progress_page: FRONTEND_ROUTES.PROGRESS,
	view_activity_page: FRONTEND_ROUTES.ACTIVITY,
};

export type ParentPasswordNamespace = keyof typeof namespacesToPathMap;

export const namespaceByPath: Record<string, ParentPasswordNamespace> = Object.entries(
	namespacesToPathMap,
).reduce<Record<string, ParentPasswordNamespace>>((acc, [namespace, path]) => {
	acc[path] = namespace as ParentPasswordNamespace;
	return acc;
}, {} as Record<string, ParentPasswordNamespace>);
